import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";

import CustomerSelect from "../../common/CustomerSelect";
import UserSelect from "../../common/UserSelect";
import ProjectSelect from "../../common/ProjectSelect";
import DepartmentSelect from "../../common/DepartmentSelect";
import ReportFilters from "../ReportFiltersComponent";

const EmployeeUtilizationFilters = ({
  onChange,
  filters,
  onResetClick,
  onFetchClick,
  loading,
  disabled,
  exportDisabled,
  onCSVExport
}) => (
  <ReportFilters
    onFetchClick={onFetchClick}
    onResetClick={onResetClick}
    title="Employee Utilization"
    loading={loading}
    disabled={disabled}
    csvExportAvailable
    exportDisabled={exportDisabled}
    onCSVExport={onCSVExport}
  >
    <Row>
      <Col md={3}>
        <CustomerSelect
          label="Customer"
          placeholder="Select"
          isMulti
          onChange={onChange("customers")}
          value={filters.customers || null}
        />
      </Col>
      <Col md={3}>
        <ProjectSelect
          label="Project"
          placeholder="Select"
          isMulti
          onChange={onChange("projects")}
          value={filters.projects || null}
        />
      </Col>
      <Col md={3}>
        <DepartmentSelect
          label="Department"
          placeholder="Select"
          isMulti
          onChange={onChange("departments")}
          value={filters.departments || null}
        />
      </Col>
      <Col md={3}>
        <UserSelect
          label="Employee"
          placeholder="Select"
          isMulti
          onChange={onChange("managers")}
          value={filters.managers || null}
        />
      </Col>
    </Row>
    <Row>
      <Col md={3}>
        <label className="control-label" style={{ textTransform: "uppercase" }}>
          Start Date
        </label>
        <input
          style={{
            padding: 8,
            border: "1px solid hsl(0,0%,80%)",
            width: "100%",
            borderRadius: 4
          }}
          type="date"
          onChange={(e) => onChange("startDate")(e.target.value)}
          value={filters.startDate || ""}
        />
      </Col>
      <Col md={3}>
        <label className="control-label" style={{ textTransform: "uppercase" }}>
          End Date
        </label>
        <input
          style={{
            padding: 8,
            border: "1px solid hsl(0,0%,80%)",
            width: "100%",
            borderRadius: 4
          }}
          type="date"
          value={filters.endDate || ""}
          onChange={(e) => onChange("endDate")(e.target.value)}
        />
      </Col>
    </Row>
  </ReportFilters>
);

EmployeeUtilizationFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onResetClick: PropTypes.func,
  onFetchClick: PropTypes.func,
  exportDisabled: PropTypes.func,
  onCSVExport: PropTypes.func
};
export default EmployeeUtilizationFilters;
